<template>
    <div class="backup" data-aos="fade-left">
        <i class="el-icon-arrow-up" @click="moveUp"></i>
        <i class="el-icon-arrow-down" @click="moveDown"></i>
        <i class="el-icon-download" @click="moveToUp"></i>
<!--        <a href="http://wpa.qq.com/msgrd?v=3&uin=2627995179&site=qq&menu=yes" target="_blank" @mouseenter="qqEnter" @mouseleave="qqLeave">-->
<!--            <img :src="src" width="25" height="25">-->
<!--        </a>-->
    </div>
</template>

<script>
export default {
    data(){
        return {
            src:require('@/assets/img/QQ.svg'),
        }
    },
    methods:{
        moveUp(){
            let top = document.documentElement.scrollTop || document.body.scrollTop
            // 实现滚动效果
            let moveMs = 0
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 10
                moveMs++
                if (moveMs >= 90) {
                    clearInterval(timeTop)
                }
            }, 10)
        },
        moveDown(){
            let top = document.documentElement.scrollTop || document.body.scrollTop
            // 实现滚动效果
            let moveMs = 0
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top += 10
                moveMs++
                if (moveMs >= 90) {
                    clearInterval(timeTop)
                }
            }, 10)
        },
        moveToUp(){
            let top = document.documentElement.scrollTop || document.body.scrollTop
            // 实现滚动效果
            const timeTop = setInterval(() => {
                document.body.scrollTop = document.documentElement.scrollTop = top -= 10
                if (top <= 0) {
                    clearInterval(timeTop)
                }
            }, 10)
        },
        qqEnter(){
            this.src = require('@/assets/img/QQ1.svg')
        },
        qqLeave(){
            this.src = require('@/assets/img/QQ.svg')
        }
    }
}
</script>

<style lang="less" scoped>
.backup{
	width: 50px;
	height: 150px;
	background: #ed1c24;
	border-radius: 30px;
	text-align: center;
	display: flex;
	align-content: space-between;
	flex-wrap: wrap;
	padding: 15px 10px;
	box-sizing: border-box;
    position:fixed;
    right: 40px;
    bottom: 42px;
    z-index: 99999999999;
	i{
		width: 30px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		border-radius: 50%;
		display: block;
		color: #fff;
        font-size: 20px;
		cursor: pointer;
	}
	i:hover{
		background: #fff;
		color: #ed1c24;
	}
	i:nth-child(3){
		transform: rotate(180deg);
	}
    a{
        display: block;
        width: 25px;
        height: 25px;
        margin: 0 auto;
        text-align: center;
        border-radius: 50%;
        &:hover{
            background: #fff;
        }
    }
}
</style>
